import { render, staticRenderFns } from "./WhatsappIntegration.vue?vue&type=template&id=5373e8f0"
import script from "./WhatsappIntegration.vue?vue&type=script&lang=js"
export * from "./WhatsappIntegration.vue?vue&type=script&lang=js"
import style0 from "./WhatsappIntegration.vue?vue&type=style&index=0&id=5373e8f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports